import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import { Flex } from 'core/ui/atoms';
import { BackgroundJobStatusCheck } from 'core/ui/components';

class BackgroundCheck extends PureComponent {
  static propTypes = {
    open: PropTypes.bool,
    backgroundJobId: PropTypes.string,
    onSuccess: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
  };

  render() {
    const { backgroundJobId, onSuccess, onError } = this.props;

    return (
      ReactDOM.createPortal(
        <Flex>
          <BackgroundJobStatusCheck
            backgroundJobId={backgroundJobId}
            onSuccess={onSuccess}
            onError={onError}
          />
        </Flex>,
      document.getElementById('modal-root'))
    );
  }
}

export default BackgroundCheck;
